/**
 * In-memory holder for the freshly-issued refresh token, captured at login so
 * the enrollment ceremony can encrypt it into the vault. NEVER persisted in
 * plaintext — lives only for this tab session.
 */
let pendingRefreshToken: string | null = null;

export function setPendingRefreshToken(token: string | null): void {
  pendingRefreshToken = token || null;
}
export function getPendingRefreshToken(): string | null {
  return pendingRefreshToken;
}
